// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__3qR-1","infoContainer":"styles_infoContainer__18oOE","header":"styles_header__3AWJu","loading":"styles_loading__18iau"};